// extracted by mini-css-extract-plugin
export default {"disclosure":"disclosure-Z7qI6"};